__turbopack_context__.v({
  "blurBg": "style-module-scss-module__K3R8eq__blurBg",
  "container": "style-module-scss-module__K3R8eq__container",
  "content": "style-module-scss-module__K3R8eq__content",
  "fade": "style-module-scss-module__K3R8eq__fade",
  "mannequin": "style-module-scss-module__K3R8eq__mannequin",
  "patternBg": "style-module-scss-module__K3R8eq__patternBg",
  "textWrapper": "style-module-scss-module__K3R8eq__textWrapper",
  "title": "style-module-scss-module__K3R8eq__title",
  "upperText": "style-module-scss-module__K3R8eq__upperText",
  "wrapper": "style-module-scss-module__K3R8eq__wrapper",
});
